// extracted by mini-css-extract-plugin
export default {"brandPromo":"qH-z","carousel":"rH-z"};